/** E.164 phone number format: +{country code}{subscriber number}, 2-15 digits total. */
export const E164_REGEX = /^\+[1-9]\d{1,14}$/;

/** Basic email format validation. */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidE164(phone: string): boolean {
  return E164_REGEX.test(phone.trim());
}

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email.trim());
}
